<script setup lang="ts">
import {ref} from "vue"
import axios from "axios"
import {useFetch} from "@vueuse/core"

const response = ref<unknown>(undefined)

const code = ref<number>(505)
const spamming = ref(false)

function randomBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

async function spamEvents(): Promise<void> {
  spamming.value = true
  response.value = []

  for (let burst = 1; burst <= 5; burst++) {
    try {
      const {data} = await axios.post("/dev/spam_events", {}, {headers: {"Content-Type": "application/json"}})
      ;(response.value as Array<unknown>).push({burst, generated: data.generated})
    } catch (err) {
      ;(response.value as Array<unknown>).push({burst, error: String(err)})
      break
    }

    if (burst < 3) {
      await sleep(randomBetween(1000, 5000))
    }
  }

  spamming.value = false
}

async function axios_boom() {
  response.value = await axios.get(`/dev/abort/${code.value}`)
}

async function usefetch_boom() {
  const fetcher = useFetch(`/dev/abort/${code.value}`).get()
  response.value = await fetcher.execute()
}

function local_boom() {
  throw new Error("Boom!")
}
</script>

<template>
  <main>
    <div class="column">
      <input v-model.number="code" placeholder="http error code">
      <b-button @click="axios_boom">Go Boom with Axios</b-button>
      <b-button @click="usefetch_boom">Go Boom with Fetch</b-button>
      <b-button @click="local_boom">Go Boom with Local Error</b-button>
      <hr style="width: 100%">
      <b-button variant="warning" :disabled="spamming" @click="spamEvents">
        {{ spamming ? "Spamming..." : "Spam Fake Email Events" }}
      </b-button>
    </div>
    <pre>{{ {response} }}</pre>
  </main>
</template>

<style scoped lang="scss">

.column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

</style>
